<template>
  <MainLayout v-if="isMainAppRoute">
    <router-view />
  </MainLayout>
  <router-view v-else />
</template>

<script>
import { computed } from "vue";
import { useRoute } from "vue-router";
import MainLayout from "@/layouts/MainLayout.vue";

export default {
  components: { MainLayout },
  setup() {
    const route = useRoute();
    const standaloneRoutes = new Set(["Login", "AdminLogin", "Forbidden"]);

    const isMainAppRoute = computed(
      () =>
        Boolean(route.name) &&
        !standaloneRoutes.has(route.name) &&
        !route.matched.some((record) => record.meta.adminArea)
    );

    return { isMainAppRoute };
  },
  mounted() {
    const spinner = document.getElementById("mainspinner");
    if (spinner) spinner.style.display = "none";
  },
};
</script>

<style>
html{
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  height: 100%;
}
body{
  padding: unset;
  margin: unset;
  height: 100%;
  background: #f5f5f5;
}
div{
  box-sizing: border-box;
}
div#app{
  height: 100%;
}
.tab {
  overflow: hidden;
  background-color: white;
  display: flex;
}
</style>
